<div
  class="placeholder-glow d-flex flex-column gap-3"
  [class.p-2]="compact"
  [class.p-3]="!compact"
  role="status"
>
  <span class="visually-hidden">{{ 'chat.states.loading' | translate }}</span>

  @for (row of rowList; track row) {
    <div class="d-flex" [class.justify-content-end]="row % 2 === 1" aria-hidden="true">
      <span
        class="placeholder chat-skeleton__bubble"
        [class.chat-skeleton__bubble--wide]="row % 3 === 0"
        [class.col-7]="row % 2 === 0"
        [class.col-5]="row % 2 === 1"
      ></span>
    </div>
  }
</div>
